/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/2/28
 */

import createModel from 'utils/model'
import {info} from 'crm/services/companies'

export default createModel({
    namespace: 'crm_companyInformation',

    state: {
        expireIn: '',
        name: '',
        product: '',
    },

    effects: {
        *info({payload}, {call, put}) {
            const {data} = yield call(info, payload)
            yield put({
                type: 'setProperty',
                payload: {
                    expireIn: data.expire_in,
                    name: data.name,
                    product: data.product,
                },
            })
            return data
        },
    },

    reducers: {},
})
